/**
 * Free Shipping Progress Bar
 * Impulse's ajax cart (theme.js) fires "updateCart.ajaxcart" on <body> every
 * time the drawer refreshes, passing the full cart.js object as the second
 * argument — including total_price. We use that instead of an extra fetch.
 */
(function () {
  var THRESHOLD_CENTS = 15000; // $150.00, matches the snippet's server-rendered value

  function renderBar(totalPriceCents) {
    var bars = document.querySelectorAll('[data-free-shipping-bar]');
    if (!bars.length) return;

    var remaining = THRESHOLD_CENTS - totalPriceCents;
    var percent = Math.min(100, Math.max(0, (totalPriceCents / THRESHOLD_CENTS) * 100));

    bars.forEach(function (bar) {
      var message = bar.querySelector('[data-free-shipping-message]');
      var fill = bar.querySelector('[data-free-shipping-fill]');

      if (message) {
        message.textContent =
          remaining > 0
            ? 'You are ' + formatMoney(remaining) + ' from qualifying for complimentary shipping'
            : 'This order qualifies for complimentary shipping';
      }
      if (fill) {
        fill.style.width = percent + '%';
      }
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function' && window.theme.settings) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    return '$' + amount;
  }

  if (window.jQuery) {
    jQuery(document).ready(function ($) {
      $('body').on('updateCart.ajaxcart', function (evt, cart) {
        if (cart && typeof cart.total_price === 'number') {
          renderBar(cart.total_price);
        }
      });
    });
  }
})();
